import { playerprofile } from "./playerprofile";

export const API = {
  ...playerprofile,
};
